export const getSchoolNameStringValue = (schoolId: number, schoolNamesObj: any) =>
  schoolNamesObj ? schoolNamesObj[schoolId] : '';
